import React from 'react'
import { isMobile } from 'utils'
export interface ILayoutContext {
	onCollapse: (collapsed: boolean) => void,
	clearNotices: () => void,
	notices: any[],
	collapsed: boolean,
	isMobile: boolean
}
const LayoutContext = React.createContext<ILayoutContext>({} as any)
export class LayoutProvider extends React.Component<React.Props<any>, ILayoutContext> {
	constructor(props: any) {
		super(props)
		this.state = {
			collapsed: false,
			notices: [],
			onCollapse: this.onCollapse,
			clearNotices: this.clearNotices,
			isMobile
		};
	}
	clearNotices = () => {
		this.setState({ notices: [] })
	}
	onCollapse = (collapsed: boolean) => {
		if (collapsed !== this.state.collapsed){
			this.setState({ collapsed })
		}	
	}
	render() {
		return (<LayoutContext.Provider value={this.state}>
			{this.props.children}
		</LayoutContext.Provider>)

	}

}
export default LayoutContext


// WEBPACK FOOTER //
// ./src/layouts/LayoutContext.tsx